/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_E2_Extra_Point_2_LabelInputs */

const en_visa_e2_extra_point_2_label = /** @type {(inputs: Visa_E2_Extra_Point_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentation Quality`)
};

const pt_visa_e2_extra_point_2_label = /** @type {(inputs: Visa_E2_Extra_Point_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualidade da Documentação`)
};

const es_visa_e2_extra_point_2_label = /** @type {(inputs: Visa_E2_Extra_Point_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calidad de la Documentación`)
};

/**
* | output |
* | --- |
* | "Documentation Quality" |
*
* @param {Visa_E2_Extra_Point_2_LabelInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_e2_extra_point_2_label = /** @type {((inputs?: Visa_E2_Extra_Point_2_LabelInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_E2_Extra_Point_2_LabelInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_e2_extra_point_2_label(inputs)
	if (locale === "es") return es_visa_e2_extra_point_2_label(inputs)
	return en_visa_e2_extra_point_2_label(inputs)
});